import React, { useState } from "react";
import Layout from "./layout.js";
import { Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import MetricCard from "../components/MetricCard.js";
import DateInput from "../components/DateInput.js";
import Button from "../components/Button.js";
import Col from "react-bootstrap/Col";
import UserIcon from "../assets/svg/users.svg";
import ActivePageIcon from "../assets/svg/activepage.svg";
import ConversionIcon from "../assets/svg/liveconversion.svg";
import DataTable from "../components/DataTable.js";
import entrypagecontent from "../assets/json/entrypagecontent.json";
import Download from "../components/Downloads.js";
import TimeSpentArticle from "../components/TimeSpentArticle.js";
import BlacklinkData from "../components/BlacklinkDataContent.js";


const ContentPerformance = () => {

    const navigate = useNavigate();

    const handleRefresh = () => {
        window.location.reload(); // This will refresh the page
    };

    const columns = [
        { headname: "BLOG TITLE", dbcol: "col1", type: "text" },
        { headname: "DESCRIPTION", dbcol: "col2", type: "text" },
        { headname: "BLOG VIEWS", dbcol: "col3", type: "text" },
        { headname: "SHARE", dbcol: "col4", type: "text" },
        { headname: "URL", dbcol: "col5", type: "text" },
    ];


    return (
        <Layout>
            <div className="d-flex align-items-center justify-content-between">
                <div className="mt-3 d-flex align-items-center">
                    <div className="d-flex gap-5 md-date">
                        <DateInput label="" type="range" includeTime={false} />
                    </div>

                    {/* Refresh Button */}
                    <div className=" mb-2 ps-3 md-refresh ">
                        <i
                            className="bi bi-arrow-repeat icon-refresh"
                            onClick={handleRefresh}
                        ></i>
                    </div>
                </div>
                <div className="text-right gap-3 ie-btn d-flex">
                    <Button
                        buttonType="^"
                        onClick={() => navigate("/add-usersegment")}
                        label="User Segment"
                    />
                </div>
            </div>

            <div className="card-container gap-4 flex-wrap">
                <Row className="metrix-container">
                    <Col xs={4} md={3}>
                        <MetricCard
                            title="Active Users"
                            operation="count"
                            column="col1"
                            icon={UserIcon} // You can change this to any Bootstrap icon name like "check-circle", "database", etc.
                            tooltipText="This shows the count of live blogs" // Tooltip for additional context
                        />
                    </Col>
                    <Col xs={4} md={3}>
                        <MetricCard
                            title="Active Pages"
                            operation="count"
                            column="col2"
                            icon={ActivePageIcon}// You can change this to any Bootstrap icon name like "check-circle", "database", etc.
                            tooltipText="This shows the count of Draft Blog" // Tooltip for additional context
                        />
                    </Col>
                    <Col xs={4} md={3}>
                        <MetricCard
                            title="Conversion"
                            operation="total"
                            column="col3"
                            icon={ConversionIcon} // You can change this to any Bootstrap icon name like "check-circle", "database", etc.
                            tooltipText="This shows the total of Views" // Tooltip for additional context
                        />
                    </Col>
                </Row>
            </div>

            <div style={{
                background: "#fff",
                padding: "24px",
                marginTop: "20px",
            }}>
                <h3 style={{ marginBottom: "20px", color: "#1A1F36", fontWeight: "600" }}>
                    Top Entry Pages
                </h3>

                <DataTable
                    id="entrypagecontent"
                    columns={columns}
                    data={entrypagecontent}
                    defaultView="table"
                    searchable={true}
                    filterable={true}
                    sortable={true}
                    paginated={true}
                />
            </div>

            <div>
                <Row>
                    <Col md={7}>
                        <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", marginTop: "20px" }}>
                            <h3>Downloads</h3>
                            <Download/>
                        </div>
                    </Col>

                    <Col md={5}>
                        <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", marginTop: "20px" }}>
                            <h3>Time Spent Article</h3>
                            <TimeSpentArticle/>
                        </div>
                    </Col>
                </Row>
            </div>

            <div>
                <Row>
                    <Col md={7}>
                        
                    </Col>
                   <Col md={5}>
                        <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", marginTop: "20px" }}>
                            <h3>Blacklink Data</h3>
                            <BlacklinkData/>
                        </div>
                    </Col>
                </Row>
            </div>
        </Layout>
    )
}

export default ContentPerformance;